module.exports = __webpack_public_path__ + "img/arrow-left.ed5b3c21.svg";